import React, { Component } from 'react'

import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'

import { mapStatsToData } from 'selectors/portals'
import { colors } from 'theme'

import { ControlsForm } from './Controls'
import CustomToolTip from './CustomToolTip'
import { months, rangeOptions } from './config'
import { chartStyle } from './styles'

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts'

class Charts extends Component {
  constructor(props) {
    super(props)
  }

  content = () => {
    const { dataCallRecordsStats } = this.props

    if (dataCallRecordsStats && dataCallRecordsStats.length > 0) {
      return (
        <div className="chart-container">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={dataCallRecordsStats}
              margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <XAxis dataKey="month" />

              <YAxis
                label={{
                  value: 'N° de llamadas',
                  angle: -90,
                  position: 'insideLeft',
                  stroke: colors.text,
                  offset: 10
                }}
              />

              <CartesianGrid strokeDasharray="3 3" />
              <Tooltip content={<CustomToolTip />} />
              <Bar dataKey="calls" fill={colors.primary} />
            </BarChart>
          </ResponsiveContainer>
          <style jsx>{chartStyle}</style>
        </div>
      )
    }
    return (
      <div className="not-content">
        <p>Sin llamadas</p>
        <style jsx>{chartStyle}</style>
      </div>
    )
  }

  render() {
    const { handleMonthChange, loading } = this.props

    return (
      <div>
        <ControlsForm
          initialValues={{
            month: months[new Date().getMonth()],
            range: rangeOptions[0].value
          }}
          onChange={handleMonthChange}
        />
        {loading ? (
          <div className="loading-content">
            <p>Cargando...</p>
            <style jsx>{chartStyle}</style>
          </div>
        ) : (
          this.content()
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { callRecordsStats } = state.portals
  const dateCallRecords = getFormValues('searchPortalsStats')(state) || {}

  return {
    dataCallRecordsStats: mapStatsToData(
      callRecordsStats.dataCallRecordsStats,
      dateCallRecords.range,
      dateCallRecords.month
    ),
    loading: callRecordsStats.loading
  }
}

export default connect(mapStateToProps)(Charts)
